export enum RegionEnum {
  af = 'af',
  eu = 'eu',
}

export const AVAILABLE_REGIONS = Object.values(RegionEnum);
